var map = {
	"./add_edit_order_modal.js": 1457,
	"./addresses.js": 7800,
	"./admin.js": 2816,
	"./approvals.js": 2110,
	"./auth.js": 7564,
	"./buyers.js": 2463,
	"./catalog_products.js": 9137,
	"./checkout.js": 2113,
	"./collections.js": 3854,
	"./company.js": 9197,
	"./contacts.js": 2774,
	"./coupon.js": 8477,
	"./dashboard.js": 2635,
	"./digital_catalog.js": 3823,
	"./discount.js": 4674,
	"./filters.js": 2225,
	"./hierarchy.js": 1393,
	"./history.js": 6787,
	"./lang.js": 3874,
	"./mega-menu.js": 5741,
	"./menus.js": 868,
	"./order-location.js": 493,
	"./orders.js": 4149,
	"./page_headers.js": 5699,
	"./payment-term.js": 9361,
	"./search.js": 7883,
	"./search_history.js": 5658,
	"./settings.js": 3381,
	"./shipping.js": 1117,
	"./tags.js": 5624,
	"./user_permission.js": 4779,
	"./website-header-logo.js": 5666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6408;